import React, { useState, useEffect, useContext } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './FilterStock.css'
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';
// import axios from 'axios';
import { StockContext } from '../../Context/StockContext';

const FilterStock = () => {

  const { stockLists, handleAddItem_filter_func, handleDeleteItem_filter_func, addedStocks } = useContext(StockContext)
  let Initial_StockList = stockLists

  const [search, setSearch] = useState("")
  const [searchResults, setSearchResults] = useState([])
  const [addedStocksState, setAddedStocksState] = useState({})

  // if(addedStocks !== null)
  // {

      // Sort the array alphabetically in place
  addedStocks.sort((a, b) => a.Name_Of_Company.localeCompare(b.Name_Of_Company))

    // }

  useEffect(() => {
    if (search !== "") {
      setSearchResults(Initial_StockList
        .filter((res) =>  res['NAME OF COMPANY'].toLowerCase().includes(search.toLowerCase()) || 
                          res['SYMBOL'].toLowerCase().includes(search.toLowerCase()))
        .filter((res) => !addedStocks.some((item) => item.symbol === res.SYMBOL))
        .slice(0, 100)
      )
    }
    setAddedStocksState(addedStocks)
  }, [search, addedStocks, Initial_StockList])


  // console.log(addedStocksState.length)
  // console.log(searchResults)

  async function handleAddItem(itemSymbol) {
      const ItemToAdd = Initial_StockList.find((item) => item.SYMBOL === itemSymbol)
      // Extract only the necessary fields from itemToAdd
      const ItemSubset = {
        symbol: ItemToAdd.SYMBOL,
        Name_Of_Company: ItemToAdd['NAME OF COMPANY'],
        acronym: ItemToAdd['acronym']
      }
  
      //Insert item into DataBase:
      handleAddItem_filter_func([ItemSubset])
  }

  async function handleDeleteItem(itemSymbol) {
    //Delete Item from DataBase:
    handleDeleteItem_filter_func({ itemSymbol })
  }



  return (
    <section className='FilterStock-container'>
      <input type="text" placeholder='Search Stocks...' value={search} onChange={(event) => setSearch(event.target.value)} />

      <div className='FilterStock-input border rounded'
        style={{ flex: search !== "" ? 1 : 0 }}
      >
        {search !== "" ? searchResults.map((item, index) => {
          return <div className='FilterStock-list m-1' key={index}>
            <li className='m-1 px-1'> <div>{item['NAME OF COMPANY'].toLowerCase()}</div> <i>{item['acronym']} - {item['SYMBOL']}</i> 
            { addedStocks.length <50 ? <AddCircleIcon className='m-1' onClick={() => handleAddItem(item.SYMBOL)}/> : null}
            </li>
          </div>
        }) : null}
      </div>


      <div className='FilterStock-addItem my-2 border rounded' >
        {addedStocks ?
        
        addedStocks.map((item, index) => {
          return <div key={index} className='FilterStock-addItem-ol'>
            <ol className='my-1 px-1 mx-0' > <div> {index + 1 + ") " + item['Name_Of_Company'].toLowerCase()}</div> <i>{item['acronym']} - {item['symbol']}</i>
              {/* <button className='my-2' onClick={() => handleDeleteItem(item.symbol)}>delete</button> */}
              <DeleteIcon className='my-2' onClick={() => handleDeleteItem(item.symbol)}/>
            </ol>
          </div>
        })
        
        :
        
        null

        }
      </div>

      <div className='FilterStock-passage'>
        <i>Total stocks added: {addedStocks.length} <i>(up to 50 stocks can be added).</i></i>
      </div>
    </section>
  )
}

export default FilterStock